export default 'Diagnostic Décret Tertiaire : calculez votre trajectoire OPERAT −40 % 2030, −50 % 2040, −60 % 2050. Bâtiment ≥ 1 000 m² ? Résultats chiffrés en 3 minutes.';
